import React, { useEffect } from 'react';
import { LandingPage } from './pages/LandingPage';
import { loadMetaPixel } from './utils/metaPixel';
interface AppProps {
  /** Shows the rotating "recent purchase" social-proof notifications. */
  showSocialProofPopup?: boolean;
}
export function App({
  showSocialProofPopup = true
}: AppProps) {
  useEffect(() => {
    loadMetaPixel();
  }, []);
  return <LandingPage showSocialProofPopup={showSocialProofPopup} data-id="element-0" data-mp="3f8nf5krqvf9m" />;
}